import ShoeOne from "../img/shoe1.png";
import ShoeTwo from "../img/shoe2.png";
import ShoeThree from "../img/shoe3.png";
import ShoeFour from "../img/shoe4.png";
import ShoeFive from "../img/shoe5.png";
import ShoeSix from "../img/shoe6.png";

export default [
  {
    cardImg: ShoeOne,
    cardPrice: 699,
  },
  {
    cardImg: ShoeTwo,
    cardPrice: 599,
  },
  {
    cardImg: ShoeThree,
    cardPrice: 499,
  },
  {
    cardImg: ShoeFour,
    cardPrice: 399,
  },
  {
    cardImg: ShoeFive,
    cardPrice: 299,
  },
  {
    cardImg: ShoeSix,
    cardPrice: 199,
  },
];
